module.exports = __webpack_public_path__ + "atendimento-corporativo.bf4823f37308ea4107d7.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/atendimento-corporativo.jpg
// module id = ../../../../../src/assets/images/backgrounds/atendimento-corporativo.jpg
// module chunks = styles